import { computed, observable } from 'mobx';

import { SerializedData, Store } from 'bernie-core';
import { AnalyticsType } from 'types/shared';
import { ResponseTagType } from '__generated__/api';

export class ClientMetadataStore extends Store {
  @observable public pageName: string;
  @observable public pageNameAnalytics: AnalyticsType;
  @observable public responseTags?: ResponseTagType[];

  @computed get isCachedResponse(): boolean {
    return this.responseTags && this.responseTags.some(tag => ResponseTagType.LISTING_CACHE_SOURCE == tag);
  }

  @computed get isPaginatedResponse(): boolean {
    return this.responseTags && this.responseTags.some(tag => ResponseTagType.LISTINGS_PAGINATED == tag);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }
}
